import Vue from "vue";
import { ResponseService } from "@/domain/response.ts";
import { RepoService } from "@/domain/repo.ts";
import { DocService } from "@/domain/doc.ts";
import { BookmarkService } from "@/domain/bookmark";

const IoC: any = {
  install(Vue: any, options: {}) {
    Vue.prototype.$ioc = {
      repoService: new RepoService(),
      responseService: new ResponseService(),
      docService: new DocService(),
      bookmarkService: new BookmarkService()
    };
  }
};

Vue.use(IoC);

interface IoC {
  repoService: RepoService;
  responseService: ResponseService;
  docService: DocService;
  bookmarkService: BookmarkService;
}

declare module "vue/types/vue" {
  interface Vue {
    $ioc: IoC;
  }
}
